import React, { PureComponent } from 'react'
import {Grid, Paper, ListItem, MenuItem, Button} from '@material-ui/core'

import { onChangeEditHOF } from '../../utils/common'
import { taxOptionList, Appcues } from '../../utils/constants'
import { getSession, hasAccess } from '../../utils/api'

import EditActionComponent from '../common/EditActionComponent'
import { EditableSelect, EditableSwitch } from '../common/EditableComponents'
import RegularTaxOptions from '../TaxOption/RegularTaxOption'
import ComplexTaxOptions from '../TaxOption/ComplexTaxOptions/ComplexTaxOptions'
import ExciseTaxOption from '../TaxOption/ExciseTaxOption'
import TaxDisplayNames from './TaxDisplayNames'
import _ from 'lodash'
import { monolithIsFeatureFlagEnable } from '../../api/unleash'
import { UnleashToggles } from '../../types/unleashToggles'
import { checkIfCDTFAEnabledAPI } from '../../api/compliance'

class TaxOption extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      taxOptionSettings: {},
      initialTaxOptionSettings: {},
      surchargeExciseTaxFlag: false,
      isCDTFAEnabled: false,
    }
  }

  TaxMenuItems = taxOptionList.map((option, key) => (
    <MenuItem value={option} key={key}>
      {option}
    </MenuItem>
  ))

  componentDidMount() {
    const user = getSession()
    const { assignedShop = {} } = user || {}
    const { address = {} } = assignedShop || {}

    const state = address && address.state
    const isShopFromCA = state === 'CA'

    this.handleGetShopSettings('exciseTax', 'TAXES')
    this.handleSurchargeExciseTax()
    isShopFromCA && this.handleCDTFA()
  }

  handleCDTFA = () => {
    checkIfCDTFAEnabledAPI()
      .then((_) => {
        this.setState({ isCDTFAEnabled: true })
      })
      .catch((_) => {
      })
  }

  handleSurchargeExciseTax = () => {
    monolithIsFeatureFlagEnable(UnleashToggles.SURCHARGE_TAX_EXCISE_TAX).then((res) => {
      this.setState({ surchargeExciseTaxFlag: res })
    })
  }

  handleGetShopSettings = (groupAttribute, groupName) => {
    this.props.getShopSettings &&
      this.props.getShopSettings(groupName, groupAttribute).then((resp) => {
        const { taxOptionSettings } = this.state
        if (resp) {
          this.setState({
            taxOptionSettings: {
              ...taxOptionSettings,
              [groupAttribute]: resp,
            },
            initialTaxOptionSettings: {
              ...taxOptionSettings,
              [groupAttribute]: resp,
            },
          })
        }
      })
  }

  onChange = onChangeEditHOF(this.props.onChange)

  handleChange = (groupName) => async (attribute, value) => {
    const { taxOptionSettings } = this.state
    const groupValue = taxOptionSettings[groupName]

    if (groupValue && groupValue[attribute] != null) {
      await this.setState({
        taxOptionSettings: {
          ...taxOptionSettings,
          [groupName]: {
            ...groupValue,
            [attribute]: value,
          },
        },
      })
    } else {
      this.props.onChange(attribute, value)
    }
  }

  onChangeComplexTax = (e) => {
    const { value } = e.target
    let useComplexTax = false

    if (value === 'Complex') {
      useComplexTax = true
    }
    this.props.onChange('useComplexTax', useComplexTax)
  }

  findShop = (id, shops) => {
    const shop = shops.find((item) => item.id === id) || {}
    return shop
  }

  getCurrentShop = (assignedShop, employeeShops) => {
    const auxShop = this.findShop(assignedShop.id, employeeShops)
    const { data } = this.props
    const currentShop = {
      ...data,
      exciseTaxInfo: auxShop.exciseTaxInfo,
    }
    return currentShop
  }

  onSave = (func) => {
    this.props.onSave((response) => {
      Appcues.track('Tax Options Saved')
      this.props.disableEdit()
      if (typeof func === 'function') {
        func()
      }
    })
  }

  handleSave = (groupName, groupAttribute) => () => {
    const { taxOptionSettings, initialTaxOptionSettings } = this.state
    const { data } = this.props

    const currentGroupValue = taxOptionSettings[groupAttribute]
    const initialGroupValue = initialTaxOptionSettings[groupAttribute]

    if (!_.isEqual(currentGroupValue, initialGroupValue)) {
      this.props.updateShopSettings(currentGroupValue, groupName)
      this.setState({
        initialTaxOptionSettings: {
          ...initialTaxOptionSettings,
          [groupAttribute]: currentGroupValue,
        },
      })

      const { exciseTax = {} } = taxOptionSettings
      const { exciseTax: initialExciseTax = {} } = initialTaxOptionSettings
      const changeFlagEnableDeliveryFeeBeforeExciseTax =
        exciseTax.enableDeliveryFeeBeforeExciseTax !==
        initialExciseTax.enableDeliveryFeeBeforeExciseTax
      const changeFlagEnableSurchargeFeeBeforeExciseTax =
        exciseTax.enableSurchargeFeeBeforeExciseTax !==
        initialExciseTax.enableSurchargeFeeBeforeExciseTax
      if (
        changeFlagEnableDeliveryFeeBeforeExciseTax &&
        exciseTax.enableDeliveryFeeBeforeExciseTax
      ) {
        data.taxTables.forEach((taxOption) => {
          if (taxOption.cityTax.taxOrder !== 'PreTaxed')
            taxOption.cityTax.activeDeliveryFeeTax = true
        })
      }
      if (
        changeFlagEnableSurchargeFeeBeforeExciseTax &&
        exciseTax.enableSurchargeFeeBeforeExciseTax
      ) {
        data.taxTables.forEach((taxOption) => {
          if (taxOption.cityTax.taxOrder !== 'PreTaxed') taxOption.cityTax.activeSurchargeTax = true
        })
      }
    }
    this.onSave()
  }

  onCustomTaxSave = (taxTables, func) => {
    this.props.onChange('taxTables', taxTables, () => this.props.onSave(func))
  }

  onCancel = () => {
    const { initialTaxOptionSettings } = this.state
    this.setState({ taxOptionSettings: initialTaxOptionSettings })
    this.props.onCancel()
  }

  onChangeHarvestTax = () => {}

  updateTaxDisplayNames = (index, data, afterSave) => {
    const { taxDisplayNames = [] } = this.props
    let updatedTaxDisplayNames = [...taxDisplayNames]
    updatedTaxDisplayNames[index] = { ...data }
    this.props.updateTaxDisplayNames(updatedTaxDisplayNames, afterSave)
  }

  render() {
    const {
      editMode = false,
      data = {},
      showExciseTax = false,
      hideEditAction = false,
      lastModified = null,
      showEdit = true,
      isNonCannabis = false,
      taxDisplayNames = [],
      lastModifiedDisplayNames = null,
      companyFeatures = {},
      hideTaxNames = false,
      isNalTaxesOnly = false,
      isNalExciseAfterCityTax = false,
      consumerTypes,
      isTaxPageEnabled = false,
    } = this.props

    const {
      taxOptionSettings = {},
      surchargeExciseTaxFlag = false,
      isCDTFAEnabled = false,
    } = this.state
    let { useComplexTax = false } = data
    let selectedTaxMode = useComplexTax ? 'Complex' : 'Regular'

    const user = getSession()
    const { assignedShop = {}, employeeShops = {} } = user
    const { appTarget, allowDelivery } = assignedShop

    const currentShop = this.getCurrentShop(assignedShop, employeeShops)
    const state = assignedShop && assignedShop.address && assignedShop.address.state

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {hasAccess() && !hideEditAction ? (
            <div className="pull-right margin-bottom-small">
              <EditActionComponent
                onSave={this.handleSave('TAXES', 'exciseTax')}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            </div>
          ) : (
            <div className="pull-right margin-bottom-small"></div>
          )}
        </Grid>
        {showExciseTax ? (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ExciseTaxOption
              data={currentShop}
              editMode={editMode}
              onChange={this.handleChange('exciseTax')}
              appTarget={appTarget}
              isNonCannabis={isNonCannabis}
              isNalTaxesOnly={isNalTaxesOnly}
              dataExciseTax={taxOptionSettings['exciseTax'] || {}}
              surchargeExciseTaxFlag={surchargeExciseTaxFlag}
            />
          </Grid>
        ) : null}
        {appTarget && appTarget === 'Distribution' ? (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <ListItem>
                <Grid container>
                  <Grid item xs={12} sm={6} md={6} lg={6} className="text-bold">
                    Harvest Tax
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <EditableSwitch
                      valueToRender={data.exciseTaxType === 'PER_ITEM' ? 'Enabled' : 'Disabled'}
                      checked={data.exciseTaxType === 'PER_ITEM'}
                      editMode={editMode}
                      onChange={this.onChangeHarvestTax}
                    />
                  </Grid>
                </Grid>
              </ListItem>
            </Paper>
          </Grid>
        ) : null}
        {!isNonCannabis && isTaxPageEnabled && (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page">
                <ListItem>
                  <Grid container>
                    <Grid
                        item xs={12} sm={6} md={6} lg={6}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                      Potency Taxes
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} style={{ position: 'relative' }}>
                      <Button
                          style={{ position: 'absolute', right: '0px', top: '-14px' }}
                          className='primary-button margin'
                          onClick={() => this.props.routing.push("/settings/company/taxes")}
                          disabled={editMode}
                      >
                        Configure
                      </Button>
                    </Grid>
                  </Grid>
                </ListItem>
              </Paper>
            </Grid>
        )}
        {appTarget && appTarget === 'Retail' ? (
          <React.Fragment>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page">
                <ListItem>
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      Tax Option
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <EditableSelect
                        value={selectedTaxMode}
                        valueToRender={selectedTaxMode}
                        onChange={this.onChangeComplexTax}
                        editMode={editMode}
                      >
                        {this.TaxMenuItems}
                      </EditableSelect>
                    </Grid>
                  </Grid>
                </ListItem>
              </Paper>
            </Grid>
            {!hideTaxNames && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        Tax Names
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <ListItem>
                          <div className="table-scroll">
                            <TaxDisplayNames
                              taxDisplayNames={taxDisplayNames}
                              onSave={this.updateTaxDisplayNames}
                              lastModifiedDisplayNames={lastModifiedDisplayNames}
                              companyFeatures={companyFeatures}
                            />
                          </div>
                        </ListItem>
                      </Grid>
                    </Grid>
                  </ListItem>
                </Paper>
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {useComplexTax ? (
                <ComplexTaxDataContext.Provider value={taxOptionSettings}>
                  <ComplexTaxOptions
                    data={data}
                    showExcise={data.enableExciseTax}
                    onSave={this.onCustomTaxSave}
                    lastModified={lastModified}
                    showEdit={showEdit}
                    isNonCannabis={isNonCannabis}
                    state={state}
                    allowDelivery={allowDelivery}
                    isNalTaxesOnly={isNalTaxesOnly}
                    isNalExciseAfterCityTax={isNalExciseAfterCityTax}
                    shopData={currentShop}
                    isCDTFAEnabled={isCDTFAEnabled}
                    consumerTypes={consumerTypes}
                  />
                </ComplexTaxDataContext.Provider>
              ) : (
                <Paper className="paper-page">
                  <RegularTaxOptions
                    editMode={editMode}
                    data={data}
                    onChange={this.props.onChange}
                    lastModified={lastModified}
                    state={state}
                    isCDTFAEnabled={isCDTFAEnabled}
                  />
                </Paper>
              )}
            </Grid>
          </React.Fragment>
        ) : null}
      </Grid>
    )
  }
}

export const ComplexTaxDataContext = React.createContext()

export default TaxOption



// WEBPACK FOOTER //
// ./src/components/TaxOption/TaxOption.js